import React, { useCallback, ReactNode, useMemo } from 'react';

import { getMyCalls } from '../../api';
import { usePagination } from '../../hooks/usePagination';
import { MyPhoneCall } from '../../types';

import { CallHistoryContext, CallHistoryContextType } from './CallHistoryContext';

interface Props {
  children: ReactNode;
}

export const CallHistoryContextProvider = ({ children }: Props) => {
  const fetchCallHistory = useCallback(async(page: number) => getMyCalls({ page, page_size: 20 }), []);

  const pagination = usePagination<MyPhoneCall>({
    fetchPage: fetchCallHistory,
    initialPage: 1,
  });

  const value: CallHistoryContextType = useMemo(
    () => ({
      callHistory: pagination.data,
      isLoading: pagination.isLoading,
      hasMore: pagination.hasMore,
      loadMore: pagination.loadMore,
      refetch: pagination.refetch,
    }),
    [pagination.data, pagination.isLoading, pagination.hasMore, pagination.loadMore, pagination.refetch],
  );

  return <CallHistoryContext.Provider value={value}>{children}</CallHistoryContext.Provider>;
};
